import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../../../../utils/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import { ICON_HEIGHT_16 } from '../../../../../Icon'
import { Link } from '../../../../../Link'
import Text from '../../../../../Text'

import {
  QA_NAME_MATCH_REQUEST_INFO,
  QA_NAME_MATCH_RULES_LINK,
} from './ApplicantFitCheckBlockRequestRow.constants'
import {
  getApplicantFitCheckMissingText,
  getApplicantFitCheckRequestState,
} from './ApplicantFitCheckBlockRequestRow.utils'

import * as styles from './ApplicantFitCheckBlockRequestRow.module.css'

import EmailIcon from '../../../../../../icons/email.svg'

function ApplicantFitCheckBlockRequestRow({
  hasRequest,
  match,
  rulesUrl,
  onRequest,
}) {
  const { t } = useTranslation()

  const { disabledReason, isDisabled } = getApplicantFitCheckRequestState({
    match,
    t,
  })

  return (
    <div className={styles.ApplicantFitCheckBlockRequestRow}>
      {hasRequest ? (
        <>
          <Button.Outlined
            beforeIconProps={{ Icon: EmailIcon, height: ICON_HEIGHT_16 }}
            disabled={isDisabled}
            height={BUTTON_HEIGHT_32}
            qaName={QA_NAME_MATCH_REQUEST_INFO}
            text={t('RentalPortal.MatchRequestInfoBtnKey')}
            tooltip={disabledReason}
            onClick={onRequest}
          />
          <Text isSecondary>
            {disabledReason ?? getApplicantFitCheckMissingText({ match, t })}
          </Text>
        </>
      ) : null}
      {rulesUrl ? (
        <Link
          {...getQaSelector({ value: QA_NAME_MATCH_RULES_LINK })}
          className={classNames(styles.rulesLink, {
            [styles.alignEnd]: hasRequest,
          })}
          to={rulesUrl}
        >
          {t('RentalPortal.MatchEditListingRulesKey')}
        </Link>
      ) : null}
    </div>
  )
}

export default ApplicantFitCheckBlockRequestRow
